<template>
  <card-modal :visible="true" :title="title" :disableOk="true" :showPreview="false">
    <div id="modal-edit-content" class="content exterior-content-modal">
      
      <div class="columns">
        <div class="column is-half">
          <label class="label">Imagem [PT] <span class="font-weight-light">(1848x1008px)</span></label>
          <figure v-if="!newImagePT && exterior.images.pt.url" 
                  class="image is-16by9 coach-image fake-dropzone" 
          >
            <img :src="exterior.images.pt.url">
            <a class="dz-remove" @click="showDropzone('imagePT')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="imagePTDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadPT"
                      v-on:vdropzone-removedfile="removePT"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Imagem [EN] <span class="font-weight-light">(1848x1008px)</span></label>
          <figure v-if="!newImageEN && exterior.images.en.url" 
                  class="image is-16by9 coach-image fake-dropzone"
          >
            <img :src="exterior.images.en.url">
            <a class="dz-remove" @click="showDropzone('imageEN')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="imageENDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadEN"
                      v-on:vdropzone-removedfile="removeEN"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <label class="label">Imagem [ES] <span class="font-weight-light">(1848x1008px)</span></label>
          <figure v-if="!newImageES && exterior.images.es.url" 
                  class="image is-16by9 coach-image fake-dropzone" 
          >
            <img :src="exterior.images.es.url">
            <a class="dz-remove" @click="showDropzone('imageES')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="imageESDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadES"
                      v-on:vdropzone-removedfile="removeES"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Imagem [FR] <span class="font-weight-light">(1848x1008px)</span></label>
          <figure v-if="!newImageFR && exterior.images.fr.url" 
                  class="image is-16by9 coach-image fake-dropzone"
          >
            <img :src="exterior.images.fr.url">
            <a class="dz-remove" @click="showDropzone('imageFR')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="imageFRDz"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="286"
                      v-bind:thumbnail-height="161"
                      v-on:vdropzone-success="successUploadFR"
                      v-on:vdropzone-removedfile="removeFR"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <label class="label">Posição</label>
          <div class="select is-fullwidth">
            <select v-model="exterior.order">
              <option v-for="order of orderOptions" :value="order.id">{{order.value}}</option>
            </select>
          </div>
        </div>
      </div>

    </div>
  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'
import Dropzone from '../Util/DropzoneForm'
import { API_ROOT, EXTERIOR_IMG_PATH } from '../../config'

export default {
  components: {
    CardModal,
    Dropzone
  },

  props: {
    title: String,
    exteriorTotal: Number,
    exteriorData: Object
  },

  data () {
    return {
      exterior: {
        exteriorId: null,
        coach: window.store.state.route.params.id,
        images: {
          pt: {
            path: null,
            url: null
          },
          en: {
            path: null,
            url: null
          },
          es: {
            path: null,
            url: null
          },
          fr: {
            path: null,
            url: null
          }
        },
        order: this.exteriorTotal + 1
      },
      newImagePT: false,
      newImageEN: false,
      newImageES: false,
      newImageFR: false
    }
  },

  beforeDestroy () {
    let trash = document.body.querySelectorAll('.dz-hidden-input')
    for (let t of trash) {
      t.remove()
    }
  },

  mounted () {
    this.setImages()
    if (this.exteriorData) {
      this.exterior.exteriorId = this.exteriorData.exteriorId
    }
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    submitIsActive () {
      return this.exterior.images.pt.path &&
             this.exterior.images.en.path &&
             this.exterior.images.es.path &&
             this.exterior.images.fr.path
    },

    orderOptions () {
      let object = []
      let target = this.exteriorTotal
      if (!this.exteriorData) {
        target += 1
      }
      for (let i = 1; i <= target; i++) {
        object.push({id: i, value: i})
      }
      return object
    },

    userToken () {
      return window.store.state.auth.token
    },

    dropzoneUploadUrl () {
      return API_ROOT + 'resource/exterior/upload?token=' + this.userToken
    }
  },

  methods: {
    setImages () {
      if (this.exteriorData) {
        for (let image of this.exteriorData.images) {
          this.exterior.images[image.lang].path = image.imagePath
          this.exterior.images[image.lang].url = image.imageUrl
        }
        this.exterior.order = parseInt(this.exteriorData.order)
      }
    },

    successUploadPT (file) {
      this.exterior.images.pt.url = EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file
      this.exterior.images.pt.path = JSON.parse(file.xhr.response).file

      this.newImagePT = false
    },

    removePT () {
      console.log('A file was been removed')
      this.exterior.images.pt.url = null
      this.exterior.images.pt.path = null
    },

    successUploadEN (file) {
      this.exterior.images.en.url = EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file
      this.exterior.images.en.path = JSON.parse(file.xhr.response).file

      this.newImageEN = false
    },

    removeEN () {
      console.log('A file was been removed')
      this.exterior.images.en.url = null
      this.exterior.images.en.path = null
    },

    successUploadES (file) {
      this.exterior.images.es.url = EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file
      this.exterior.images.es.path = JSON.parse(file.xhr.response).file

      this.newImageES = false
    },

    removeES () {
      console.log('A file was been removed')
      this.exterior.images.es.url = null
      this.exterior.images.es.path = null
    },

    successUploadFR (file) {
      this.exterior.images.fr.url = EXTERIOR_IMG_PATH + JSON.parse(file.xhr.response).file
      this.exterior.images.fr.path = JSON.parse(file.xhr.response).file

      this.newImageFR = false
    },

    removeFR () {
      console.log('A file was been removed')
      this.exterior.images.fr.url = null
      this.exterior.images.fr.path = null
    },

    showDropzone (selector) {
      if (selector === 'imagePT') {
        this.newImagePT = true
        this.removePT()
      }

      if (selector === 'imageEN') {
        this.newImageEN = true
        this.removeEN()
      }

      if (selector === 'imageES') {
        this.newImageES = true
        this.removeES()
      }

      if (selector === 'imageFR') {
        this.newImageFR = true
        this.removeFR()
      }
    }
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        if (this.exteriorData) {
          window.store.dispatch('updateExterior', this.exterior)
        } else {
          window.store.dispatch('saveExterior', this.exterior)
        }
      }
      if (val === 'modal-card-preview') {
        // no preview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    },

    submitIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
      }
    }
  }
}
</script>

<style lang="styl">
  @import '~quill/assets/snow';
</style>

<style>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';

  .is-hidden {
    display: none !important;
  }

  #imagePTDz,
  #imageENDz,
  #imageESDz,
  #imageFRDz {
    height: 165px;
    display: flex;
  }

  #imagePTDz.dropzone .dz-preview .dz-error-message,
  #imageENDz.dropzone .dz-preview .dz-error-message,
  #imageESDz.dropzone .dz-preview .dz-error-message,
  #imageFRDz.dropzone .dz-preview .dz-error-message {
    top: 90px;
    left: 73px;
  }

  #imagePTDz.dropzone .dz-message,
  #imageENDz.dropzone .dz-message,
  #imageESDz.dropzone .dz-message,
  #imageFRDz.dropzone .dz-message {
    margin: 4em auto;
  }

  .content #imagePTDz a:not(.button):hover,
  .content #imageENDz a:not(.button):hover,
  .content #imageESDz a:not(.button):hover,
  .content #imageFRDz a:not(.button):hover {
    border-bottom-color: inherit;
  }

  .fake-dropzone {
    border: 1px solid #dbdbdb;
    border-radius: 3px;
  }

  .fake-dropzone .dz-remove {
    font-family: 'Roboto', sans-serif;
    color: #777;
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 15px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
    text-align: center;
    display: block;
    cursor: pointer;
    background-color: rgba(37, 148, 139, 0.8);
  }

  .fake-dropzone:hover .dz-remove {
    opacity: 1;
  }

  .fake-dropzone a:not(.button) {
    border-bottom: 2px white solid !important;
  }

  .fake-dropzone a:not(.button):hover, .content #slideForeground2 a:not(.button):hover {
    border-bottom-color: inherit !important;
  }
</style>


// WEBPACK FOOTER //
// ExteriorEditModal.vue?92969930